<eaglei-leaflet-layer-header [layer]="this" hideLegend (activeToggled)="toggleLayer($event)"> </eaglei-leaflet-layer-header>

<ng-container *ngIf="isActive">
    <div #legendElement>
        <div class="vertical-legend box-legend">
            <div class="legend-row">
                <div class="legend-box" style="background-color: #800"></div>
                <span class="sml-text"> Wildfire Perimeter</span>
            </div>
        </div>
    </div>
</ng-container>
